import * as React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import { useStoreActions, useStoreState } from 'easy-peasy';
import { Post } from '../services/http';
import { validateForm } from '../services/validate';
import UploadImage from '../services/upload-image';
import './dialog.css';
import AddIcon from '@mui/icons-material/Add';


export default function DonationPopUp() {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState(null);
    const [partnerLink, setPartnerLink] = React.useState(null);
    const openInfoPopup = useStoreActions((actions) => actions.open);
    const config = useStoreState((state) => state.config);
    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (
        <div>
            <div className="" >
            <div className="" onClick={handleClickOpen}>
                                            <a href="#" className="side-context__button"> <span style={{ marginRight: 10, background: 'white', borderRadius: '50%', paddingLeft: '6px', paddingRight: '6px' }}> <AddIcon style={{ color: '#088fdd' }} /> </span> VIEW MORE</a>
                                        </div>
            </div>
            <div id="popup-login" className={open ? 'popup _open' : 'popup'}>
                <div class="popup__body">
                    <div class="popup__content" style={{ position: 'relative', background: '#FAFAFA' }}>
                        <div class="login-form">
                            {/* <h3 class="color-1 rubik weight-600 f-24">Create a UTM link</h3> */}
                            {/* <hr style={{ border: '1px solid', color: 'rgba(21, 121, 190, 1)' }} /> */}
                            <p class="remove-margin-bottom" onClick={handleClose} style={{ cursor: 'pointer', color: 'red', position: 'absolute', top: 10, right: 10 }}><CloseIcon style={{ fontSize: '30px' }} /></p>
                            {/* <div class="center-text-and-line"> */}
                            <div class="form-button">
                                <p className="color-1 mb-0 rubik weight-600 f-35">
                                    DONATIONS
                                </p>
                                <div className="flex-container">
                                    <div className="flex-item-left">
                                        <p className="mb-0 roboto weight-400 f-25">452 donors</p>
                                    </div>
                                    <div className="flex-item-right">
                                        <div style={{ border: ' 1px solid #1979BE', borderRadius: '5px', height: '50px', padding: '0', paddingLeft: '10px', paddingRight: '10px' }}>
                                            <input type="text" className="roboto f-normal weight-400 f-16 color-1" placeholder="donors search..." style={{ border: 'none', background: 'transparent' }} />
                                        </div>
                                    </div>
                                </div>
                                <div style={{ marginTop: '20px' }}>
                                    <table className="" style={{ width: '100%' }}>
                                        <thead style={{ background: '#1D1E1D', color: 'white' }}>
                                            <tr className="t-center">
                                                <th className="rubik th weight-700 f-18">Date</th>
                                                <th className="rubik th weight-700 f-18">Name</th>
                                                <th className="rubik th weight-700 f-18">Note</th>
                                                <th className="rubik th weight-700 f-18">Sum</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="t-center tr">
                                                <td className="rubik td  weight-500 f-16 f-mobile">01/11/21</td>
                                                <td className="rubik td  weight-500 f-16 f-mobile">Israel Israeli</td>
                                                <td className="rubik td  weight-400 f-12 w-120 t-left">For rescue. And to pray for all the patients in the world. May everyone be healthy</td>
                                                <td className="rubik td weight-500 f-16 f-mobile color-1">$12</td>
                                            </tr>
                                            <tr className="t-center tr">
                                                <td className="rubik td  weight-500 f-16 f-mobile">01/11/21</td>
                                                <td className="rubik td  weight-500 f-16 f-mobile">Israel Israeli</td>
                                                <td className="rubik td  weight-400 f-12 w-120 t-left">For rescue. And to pray for all the patients in the world. May everyone be healthy</td>
                                                <td className="rubik td weight-500 f-16 f-mobile color-1">$12</td>
                                            </tr>
                                            <tr className="t-center tr">
                                                <td className="rubik td  weight-500 f-16 f-mobile">01/11/21</td>
                                                <td className="rubik td  weight-500 f-16 f-mobile">Israel Israeli</td>
                                                <td className="rubik td  weight-400 f-12 w-120 t-left">For rescue. And to pray for all the patients in the world. May everyone be healthy</td>
                                                <td className="rubik td weight-500 f-16 f-mobile color-1">$12</td>
                                            </tr>
                                            <tr className="t-center tr">
                                                <td className="rubik td  weight-500 f-16 f-mobile">01/11/21</td>
                                                <td className="rubik td  weight-500 f-16 f-mobile">Israel Israeli</td>
                                                <td className="rubik td  weight-400 f-12 w-120 t-left">For rescue. And to pray for all the patients in the world. May everyone be healthy</td>
                                                <td className="rubik td weight-500 f-16 f-mobile color-1">$12</td>
                                            </tr>
                                            <tr className="t-center tr">
                                                <td className="rubik td  weight-500 f-16 f-mobile">01/11/21</td>
                                                <td className="rubik td  weight-500 f-16 f-mobile">Israel Israeli</td>
                                                <td className="rubik td  weight-400 f-12 w-120 t-left">For rescue. And to pray for all the patients in the world. May everyone be healthy</td>
                                                <td className="rubik td weight-500 f-16 f-mobile color-1">$12</td>
                                            </tr>
                                            <tr className="t-center tr">
                                                <td className="rubik td  weight-500 f-16 f-mobile">01/11/21</td>
                                                <td className="rubik td  weight-500 f-16 f-mobile">Israel Israeli</td>
                                                <td className="rubik td  weight-400 f-12 w-120 t-left">For rescue. And to pray for all the patients in the world. May everyone be healthy</td>
                                                <td className="rubik td weight-500 f-16 f-mobile color-1">$12</td>
                                            </tr>
                                            <tr className="t-center tr">
                                                <td className="rubik td  weight-500 f-16 f-mobile">01/11/21</td>
                                                <td className="rubik td  weight-500 f-16 f-mobile">Israel Israeli</td>
                                                <td className="rubik td  weight-400 f-12 w-120 t-left">For rescue. And to pray for all the patients in the world. May everyone be healthy</td>
                                                <td className="rubik td weight-500 f-16 f-mobile color-1">$12</td>
                                            </tr>
                                            <tr className="t-center tr">
                                                <td className="rubik td  weight-500 f-16 f-mobile">01/11/21</td>
                                                <td className="rubik td  weight-500 f-16 f-mobile">Israel Israeli</td>
                                                <td className="rubik td  weight-400 f-12 w-120 t-left">For rescue. And to pray for all the patients in the world. May everyone be healthy</td>
                                                <td className="rubik td weight-500 f-16 f-mobile color-1">$12</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="flex justify-end">
                                        <div className="flex-container-2">
                                            <div className="roboto weight-400 f-14 pagination-btn">
                                                Previous
                                            </div>
                                            <div className="roboto weight-400 f-14 pagination-btn">
                                                1
                                            </div>
                                            <div className="roboto weight-400 f-14 pagination-btn active">
                                                2
                                            </div>
                                            <div className="roboto weight-400 f-14 pagination-btn">
                                                3
                                            </div>
                                            <div className="roboto weight-400 f-14 pagination-btn">
                                                4
                                            </div>
                                            <div className="roboto weight-400 f-14 pagination-btn">
                                                ...
                                            </div>
                                            <div className="roboto weight-400 f-14 pagination-btn">
                                                Next
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* </div> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
